var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgEmail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#CFE0FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5583 15.79C18.6239 15.616 12.1789 10.0336 12.1789 10.0336C11.2367 9.35062 10.7412 9.33987 9.80955 10.0336C9.80955 10.0336 3.37553 15.6115 3.43878 15.7831L3.43726 15.7844C3.43803 15.7859 3.43928 15.7869 3.44033 15.7882C3.50406 15.9589 3.59676 16.1177 3.7145 16.2579C3.76424 16.3171 3.82418 16.3668 3.88182 16.4184L3.87902 16.4205C3.88361 16.4245 3.88972 16.4264 3.89432 16.4304C4.13863 16.6445 4.44674 16.7831 4.78902 16.8227C4.79439 16.8233 4.79871 16.8261 4.80408 16.8267H4.82474C4.87678 16.8316 4.92625 16.8439 4.97954 16.8439H17.0255C17.7251 16.8439 18.3178 16.4117 18.5533 15.8058C18.5561 15.8013 18.5604 15.7981 18.563 15.7934L18.5583 15.79Z",
    fill: "#2F7AFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0052 9.39312L3.47754 15.7356V6.75042C3.47754 5.87462 4.20009 5.16479 5.09158 5.16479H16.9187C17.8102 5.16479 18.5328 5.87462 18.5328 6.75042V15.7356L11.0052 9.39312Z",
    fill: "#2F7AFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57484 6.21059C3.51031 6.38193 9.83934 11.8782 9.83934 11.8782C10.767 12.5507 11.2549 12.5613 12.1722 11.8782C12.1722 11.8782 18.504 6.38638 18.4417 6.21739L18.4432 6.21616C18.4425 6.21467 18.4412 6.21371 18.4402 6.21235C18.3775 6.04432 18.3033 5.91198 18.1703 5.74993C18.1108 5.67742 18.0617 5.62606 18.005 5.57524L18.0077 5.57315C18.0032 5.5692 17.9972 5.56735 17.9927 5.5634C17.7521 5.35261 17.4488 5.21606 17.1118 5.17708C17.1065 5.17645 17.1022 5.17377 17.097 5.17314H17.0766C17.0254 5.16833 16.9767 5.15625 16.9242 5.15625L5.08403 5.17293C4.39521 5.17293 3.81162 5.59849 3.57987 6.19499C3.5771 6.19944 3.57285 6.20266 3.57031 6.2072L3.57484 6.21059Z",
    fill: "#A7C7FD"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/email.46c89da8.svg";
export { ForwardRef as ReactComponent };